export default "/_next/static/media/new-editor.30e909d8d9ff07b18467be093b3123ec.png";